<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-file-excel-o"></i>  Export users</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column">
                <users-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="users" v-bind:actions="true"></users-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import UserRepo from '../../repos/UserRepo'
import lodash from 'lodash'
import UsersTable from "./Table";
var fileDownload = require('js-file-download');

export default {
  name: 'users-view',
  components: {UsersTable},
  data() {
        return {
            repo: new UserRepo(this.$auth),
            users: [],
            total: 0,
            q: '',
            orderBy: 'users.id,asc',
            page: 1,
            sort: 'users.id',
            direction: 'asc',
        }
  },
  created(){
  },
  methods: {

    onOrderBy(data){
        this.sort = data.sort;
        this.direction = data.direction;
        //`console.log(data);
        this.getUsersForExport(data);
    },
    onPageChanged(data){
        this.page = data.page;
        this.getUsersForExport(data);
    },
      onSearch(data){
          this.page = 1;
          this.sort = 'users.id';
          this.direction = 'asc';
          this.getUsersForExport(data);
      },
      getUsersForExport(data){
          let search =  Object.assign(data,
              {
                  'sort':this.sort,
                  'direction':this.direction,
                  'page':this.page
              });
          this.repo.export(search).then(response => {
              if(search.export){
                  fileDownload(response.data, 'export.csv');
              }else{
                  this.users = response.data.data;
                  this.total = response.data.meta.pagination.total_pages;
              }
          });
      },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/user-export/View.vue